package app.bloomey.web.core.data

import app.bloomey.web.core.data.models.Environment
import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.plugins.logging.*
import io.ktor.client.request.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

object ApiClient {
    val client = HttpClient(Js) {
        install(Logging) {
            logger = Logger.DEFAULT
            level = LogLevel.ALL
        }
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
            })
        }
        defaultRequest {
            val baseUrl = when (Envars.environment) {
                Environment.development -> "http://localhost:8080/api/"
                Environment.staging -> "https://bloomey-staging.up.railway.app/api/"
                Environment.production -> "https://bloomey-production.up.railway.app/api/"
            }
            url(baseUrl)
            contentType(ContentType.Application.Json)
            SessionManager.authToken.takeIf { it.isNotEmpty() }?.let { token ->
                header(HttpHeaders.Authorization, "Bearer $token")
            }
        }
    }
}